import React, { useEffect } from 'react';
import '../../styles/LoadingTest.css';
const Loader = () => {
	return (
		<div
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				minHeight: 'calc(100vh - 200px)', // Adjust this value based on your layout
				width: '100%',
			}}
		>
			<div
				className="loading-spinner"
				style={{
					width: '50px',
					height: '50px',
					border: '4px solid #f3f3f3',
					borderTop: '4px solid #4B4BF5',
					borderRadius: '50%',
					animation: 'spin 1s linear infinite',
				}}
			/>
		</div>
	);
};

export default Loader;
